<script lang="ts">
  import AssetShelf from './AssetShelf.svelte';
  let { category }: { category: string } = $props();
</script>
<div class="mb-4 tym-card p-4"><AssetShelf kind="datasheet" {category} compact /></div>
